import { makeStyles } from "@material-ui/styles";
export default makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: "14px 18px 20px",
    [theme.breakpoints.up("sm")]: {
      padding: "20px 40px",
    },
    // marginLeft: "260px",
    marginTop: 64,
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing(6)}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    ...theme.mixins.toolbar,
  },
}));
